<template>
  <div v-if="getDistributions.length > 1 && getCatalog.is_part_of  !== 'erpd'"
       class="dsd-download-all-distributions-button">
    <pv-button v-if="isLoadingAllDistributionFiles" :small="small" :rounded="true" :primary="primary" :download="true"
               class="download-all-btn"
    >
      <div class="loading-spinner"></div>
      {{ $t('message.datasetDetails.datasets.downloadAll') }} 
    </pv-button>
    <pv-button v-else class="download-all-btn" :small="small" :rounded="true" :primary="primary" :download="true"
               :action="openRessourceAccessPopup">
      {{ $t('message.datasetDetails.datasets.downloadAll') }}
    </pv-button> 
    
    <div class="modal fade" data-backdrop="static" data-keyboard="false" id="downloadAllModal" ref="downloadAllModal"
         tabindex="-1" role="dialog" aria-labelledby="download progress" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">{{ $t('message.datasetDetails.datasets.modal.downloadProgress') }}</h3>
            <!--            <button type="button" class="close" data-dismiss="modal" aria-label="Close">-->
            <!--              <span aria-hidden="true">&times;</span>-->
            <!--            </button>-->
          </div>
          <div class="modal-body">
            <div class="progress">
              <div class="progress-bar" role="progressbar" :style="{width: `${downloadProgress}%`}"
                   :aria-valuenow="downloadProgress" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <div>
              {{ $t('message.datasetDetails.datasets.modal.downloadingFiles') }}
              {{ downloadedFilesCounter.toLocaleString('fi') }}/{{ getDistributions.length.toLocaleString('fi') }}
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <div>{{ $t('message.datasetDetails.datasets.modal.notDownloaded') }}
                {{ failedDownloads.toLocaleString('fi') }}
              </div>
              <i class="material-icons help-icon" data-toggle="tooltip" data-placement="bottom"
                 :title="$t('message.datasetDetails.datasets.modal.notDownloadedTooltip')">help</i>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <div>{{
                  $t('message.datasetDetails.datasets.modal.zipNumberOfFiles', {number: numberOfFilesToZip.toLocaleString('fi')})
                }}
                <span v-if="isLoadingAllDistributionFiles && numberOfFilesToZip > 0">
                  {{ $t('message.datasetDetails.datasets.modal.coupleOfMinutes') }}
                </span> <span v-else-if="isLoadingAllDistributionFiles">
                  {{ $t('message.datasetDetails.datasets.modal.waitingForDownload') }}
                </span>
              </div>
              <div v-if="isGeneratingZip" class="spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <i v-else-if="isGeneratingZipDone" class="material-icons check-icon">check_circle</i>
            </div>
          </div>
          <div class="modal-footer">
            <!--            <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $t('message.datasetDetails.datasets.modal.close') }}</button>-->
            <button v-if="!downloadAllSuccess && !downloadAllError" type="button" class="btn btn-danger"
                    data-dismiss="modal" @click="cancelDownloadAll(cancelDownloadAllAxiosRequestSource)">
              {{ $t('message.datasetDetails.datasets.modal.cancel') }}
            </button>
            <button v-if="downloadAllError" type="button" class="btn btn-danger"
                    @click="trackAndDownloadAllDistributions()">{{ $t('message.datasetDetails.datasets.modal.error') }}
            </button>
            <button v-else-if="downloadAllSuccess" type="button" class="btn btn-success" data-dismiss="modal">
              {{ $t('message.datasetDetails.datasets.modal.okay') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {onUnmounted} from 'vue';
import {useRouter} from 'vue-router';

import {has, isNil} from "lodash";
import axios from "axios";
import {saveAs} from 'file-saver';
import $ from "jquery";
import {helpers} from "@piveau/piveau-hub-ui-modules";

const {getTranslationFor} = helpers;


/*function getCleanOrigin(urlString) {
  try {
    // Add protocol if missing (required for URL constructor)
    const url = new URL(urlString.includes('://') ? urlString : `https://${urlString}`);
    return url.hostname;
  } catch (error) {
    console.error("Invalid URL:", urlString);
    return ''; // or throw error
  }
} */


export default {
  name: "DownloadAllDistributions",
  props: [
    'getDistributionDescription',
    'getDistributionTitle',
    'openModal',
    'isUrlInvalid',
    'showDownloadUrls',
    'primary',
    'small'
  ],
  computed: {
    ...mapGetters('datasetDetails', [
      'getDistributions',
      'getTitle',
      'getCatalog',
      'getLanguages'
    ]),
    files() {
      const cutFormatEnding = string => (string.lastIndexOf('.') !== -1 ? string.substring(0, string.lastIndexOf('.')) : string);
      const getFormat = (distribution) => {
        if (has(distribution, 'format.id') && !isNil(distribution.format.id)) {
          const type = distribution.format.id;
          return type.lastIndexOf('.') === -1 ? type.toLowerCase() : type.substring(type.lastIndexOf('.') + 1, type.length).toLowerCase();
        }
        return '';
      };
      const getFileName = (distribution, i) =>
        `${cutFormatEnding(this.getDistributionTitle(distribution)).substring(0, this.bulkDownload.MAX_FILE_TITLE_LENGTH)
          .replace(/\//g, ' ').trim()}-${i}`
        || `${cutFormatEnding(this.getDistributionDescription(distribution)).substring(0, this.bulkDownload.MAX_FILE_TITLE_LENGTH)
          .replace(/\//g, ' ').trim()}-${i}`;
      const getUrls = distribution => (this.showDownloadUrls(distribution) ?
        {accessUrl: `${distribution.accessUrl[0]}`, downloadUrl: `${distribution.downloadUrls[0]}`}
        : {accessUrl: `${distribution.accessUrl[0]}`});
      const getFileNameForCSV = distribution => this.getDistributionTitle(distribution).replace(/,/g, '')
        || this.getDistributionDescription(distribution).replace(/,/g, '');
      const files = this.getDistributions
        .map((distribution, i) => ({
          title: getFileName(distribution, i + 1), ...getUrls(distribution),
          format: getFormat(distribution),
          csvReportTitle: getFileNameForCSV(distribution),
        }));
      return files
    }

  },
  data() {
    return {
      downloadedFilesCounter: 0,
      numberOfFilesToZip: 0,
      downloadProgress: 0,
      failedDownloads: 0,
      isGeneratingZip: false,
      isGeneratingZipDone: false,
      isLoadingAllDistributionFiles: false,
      cancelDownloadAllAxiosRequestSource: null,
      isDownloadAllDistributionsCanceled: false,
      downloadAllSuccess: false,
      downloadAllError: false,
      bulkDownload: {
        MAX_FILE_TITLE_LENGTH: this.$env.content.datasetDetails.bulkDownload.MAX_FILE_TITLE_LENGTH,
        TIMEOUT_MS: this.$env.content.datasetDetails.bulkDownload.TIMEOUT_MS,
      },
      catalogsWhitelist: [
        "Eurostat",
        "Joint Research Centre",
        "European Environment Agency",
        "Directorate-General for Communication",
        "EUMETSAT Product Navigator",
        "EEA SDI - geospatial data catalogue",
        "Directorate-General for Communications Networks, Content and Technology",
        "Publications Office",
        "European Banking Authority",
        "Directorate-General for International Partnerships",
        "OpenDataScienceEurope",
        "Service for Foreign Policy Instruments",
        "Directorate-General for Justice and Consumers",
        "European Parliament",
        "ESIF",
        "Directorate-General for Employment, Social Affairs and Inclusion",
        "Frontex",
        "European Centre for Disease Prevention and Control",
        "OpenAIRE",
        "European Monitoring Centre for Drugs and Drug Addiction",
        "Directorate-General for Agriculture and Rural Development",
        "European Medicines Agency",
        "Directorate-General for Competition",
        "Directorate-General for Environment",
        "Directorate-General for Regional and Urban Policy",
        "SESAR Joint Undertaking",
        "European Central Bank",
        "European Securities and Markets Authority",
        "Europol",
        "SALTED Project",
        "Directorate-General for Internal Market, Industry, Entrepreneurship and SMEs",
        "Fusion for Energy Joint Undertaking",
        "Directorate-General for Neighbourhood and Enlargement Negotiations",
        "European Chemicals Agency",
        "Directorate-General for Taxation and Customs Union",
        "European Food Safety Authority",
        "Directorate-General for Mobility and Transport",
        "Directorate-General for Economic and Financial Affairs",
        "European Institute for Gender Equality",
        "European Maritime Safety Agency",
        "Directorate-General for Energy",
        "European Union Agency for Fundamental Rights",
        "Directorate-General for Research and Innovation",
        "European Court of Auditors",
        "Directorate-General for European Civil Protection and Humanitarian Aid Operations (ECHO)",
        "European Data Protection Supervisor",
        "INTERSTAT",
        "Directorate-General for Informatics",
        "European Union Agency for Railways",
        "Eurofound",
        "European Insurance and Occupational Pensions Authority",
        "Directorate-General for Health and Food Safety",
        "European Fisheries Control Agency",
        "European Investment Bank",
        "European Union Agency for the Cooperation of Energy Regulators",
        "European Asylum Support Office",
        "European Defence Agency",
        "Directorate-General for Maritime Affairs and Fisheries",
        "Secretariat-General",
        "European Climate, Infrastructure and Environment Executive Agency",
        "data.europa.eu",
        "European Education and Culture Executive Agency",
        "Directorate-General for Human Resources and Security",
        "European Ombudsman",
        "Cedefop",
        "Open Maps for Europe",
        "European Agency for the Operational Management of Large-Scale IT Systems in the Area of Freedom, Security and Justice",
        "European Union Intellectual Property Office",
        "European Agency for Safety and Health at Work",
        "Regulatory Scrutiny Board",
        "Directorate-General for Budget",
        "Council of the European Union",
        "European External Action Service",
        "Directorate-General for Financial Stability, Financial Services and Capital Markets Union",
        "European Anti-Fraud Office",
        "Agency for Support for BEREC",
        "Translation Centre",
        "European Committee of the Regions",
        "Community Plant Variety Office",
        "Directorate-General for Education, Youth, Sport and Culture",
        "European Union Aviation Safety Agency",
        "European Economic and Social Committee",
        "European GNSS Agency",
        "European Innovation Council and SMEs Executive Agency",
        "European Union Agency for Cybersecurity",
        "European Training Foundation",
        "Europeana Datasets",
        "CB-EDP integration context data catalogue",
        "Consumers, Health, Agriculture and Food Executive Agency",
        "Directorate-General for Translation",
        "Executive Agency for Small and Medium-sized Enterprises",
        "European Institute of Innovation and Technology",
        "European Political Strategy Centre",
        "European Personnel Selection Office",
        "European Research Council Executive Agency",
        "European Health and Digital Executive Agency",
        "Directorate-General for Migration and Home Affairs",
        "Office for Infrastructure and Logistics in Brussels",
        "Office for Infrastructure and Logistics in Luxembourg",
        "Open Music Observatory",
        "Directorate-General for Interpretation",
        "Directorate-General for Trade"
      ]
    }
  },
  methods: {

    getTranslationFor,
    async fetchDistributionFiles(zip, files, folder, getContentTypeFormat) {
      const csvReportArray = [];
      let csvReport = 'distribution_name, file_name, status, issue_cause downloadURL, issue_cause accessURL\n';
      let csvDownloadURLIssue;
      const problematicFormats = ['wms', 'wfs'];

      const getFilenameFromContentDisposition = (header) => {
        if (!header) {
          console.log("getFilenameFromContentDisposition header is null");
          return null;
        }
        // Handle UTF-8 filenames (filename*=UTF-8'' format)
        const utf8Filename = header.match(/filename\*=(?:UTF-8'')?"(.+?)"/i);
        if (utf8Filename?.[1]) return decodeURIComponent(utf8Filename[1]);

        // Handle regular filename
        const match = header.match(/filename="?(.+?)"?(;|$)/i);
        return match?.[1]?.replace(/^"+|"+$/g, '') || null;
      };

      const CancelToken = axios.CancelToken;
      this.cancelDownloadAllAxiosRequestSource = CancelToken.source();
      const axiosInstance = this.$bulkDownloadAxiosInstance;

      //const proxyOrigin = this.$env.api.corsproxyApiUrl;
      //const cleanOrigin = getCleanOrigin(proxyOrigin);
      //console.log("cleanOrigin is:", cleanOrigin);
      const requestSettings = {
        responseType: 'blob',
        cancelToken: this.cancelDownloadAllAxiosRequestSource.token,
        timeout: this.bulkDownload.TIMEOUT_MS,
        //Let the browser handle CORS headers automatically. The Origin header is controlled by the browser for security reasons and cannot be overridden programmatically.
        //headers: {
        //  Origin: cleanOrigin,
        //},
      };

      const promises = files.map(async (file) => {
        const problematicFormat = problematicFormats.find(format => format === file.format);
        if (!problematicFormat) {
          let isRejected = true;
          let responseData;
          let fileFormat = file.format;
          let finalFilename;

          // try to download from download url
          if (file.downloadUrl) { // Ensure the URL is valid and present
            try {
              const response = await axiosInstance.get(file.downloadUrl, requestSettings);
              if (response.status !== 200) {
                throw new Error(`Request failed for ${file.downloadUrl} with status ${response.status}` );
              }
              isRejected = false;
              const content_type  = getContentTypeFormat(response.headers['content-type']);
              console.log("content_type downloadUrl is:", content_type); // Add for debugging

              //if (file.format.length > 0) console.log("fileFormat downloadUrl file.format is:", file.format); // Add for debugging
              const generateFallbackFilename = () => {
                const extension = content_type || fileFormat || 'bin';
                return `${this.downloadedFilesCounter}_file.${extension}`;
              };
              // Extract filename from headers
              const contentDisposition = response.headers?.['content-disposition'] ||
                response.headers?.['Content-Disposition'] || '';
              console.log("Content-Disposition is:", contentDisposition); // Add for debugging
              const filenameFromHeader = getFilenameFromContentDisposition(contentDisposition);

              console.log("fetchDistributionFiles:downloadUrl:filenameFromHeader:", filenameFromHeader);
              // 3. Final filename with fallbacks
              finalFilename = filenameFromHeader
                ? `${this.downloadedFilesCounter}-${filenameFromHeader}`
                : generateFallbackFilename();
              console.log("fetchDistributionFiles:downloadUrl:finalFilename:", finalFilename);
              csvReportArray.push([file.csvReportTitle, finalFilename, 'delivered']);
              responseData = response.data;
            } catch (error) {
              console.log("error:", error.message);
              isRejected = true;
              csvDownloadURLIssue = error;
              responseData = null; // Explicitly set to avoid undefined
              console.error("Error fetching file:", error.message);
            }

          } else csvDownloadURLIssue = 'no download url available';

          if (this.isUrlInvalid(file.downloadUrl)) {
            csvReportArray.push([file.csvReportTitle, 'issue', 'url is invalid']);
          }
          // try to download from access url
          if (isRejected) {
            responseData = await axiosInstance.get(file.accessUrl, requestSettings).then((responseAccessUrl) => {
              if (responseAccessUrl.status === 200) {
                isRejected = false;
                const content_type  = getContentTypeFormat(responseAccessUrl.headers['content-type']);
                console.log("content_type AccessUrl is:", content_type); // Add for debugging

                //if (file.format.length > 0) console.log("fileFormat AccessUrl file.format is:", file.format); // Add for debugging
                const generateFallbackFilename = () => {
                  const extension = content_type || fileFormat || 'bin';
                  return `${this.downloadedFilesCounter}_file.${extension}`;
                };
                // Get filename from Content-Disposition header
                const filenameFromHeader = getFilenameFromContentDisposition(responseAccessUrl.headers['content-disposition']);
                console.log("fetchDistributionFiles:accessUrl:filenameFromHeader:", filenameFromHeader);
                // 3. Final filename with fallbacks
                finalFilename = filenameFromHeader
                  ? `${this.downloadedFilesCounter}-${filenameFromHeader}`
                  : generateFallbackFilename();
                console.log("fetchDistributionFiles:accessUrl:finalFilename:" + finalFilename);

                csvReportArray.push([file.csvReportTitle, finalFilename, 'delivered', csvDownloadURLIssue]);
                return responseAccessUrl.data;
              }
              return Promise.reject(new Error(responseAccessUrl.statusText));
            }).catch((error) => {
              isRejected = true;
              csvReportArray.push([file.csvReportTitle, 'issue', csvDownloadURLIssue, error]);
            });
          }
          if (!isRejected)
            //folder.file(`${file.title}.${fileFormat}`, responseData, { binary: true });
            folder.file(finalFilename, responseData, {binary: true});
          if (!this.isDownloadAllDistributionsCanceled) {
            this.downloadedFilesCounter += 1;
            this.downloadProgress = Math.floor(100 * this.downloadedFilesCounter / this.getDistributions.length);
            if (isRejected) this.failedDownloads += 1;
          } else {
            this.downloadedFilesCounter = 0;
            this.downloadProgress = 0;
            this.failedDownloads = 0;
          }
        } else csvReportArray.push([file.csvReportTitle, 'issue', `We can't download ${problematicFormat} files using the download all button. Please try to download this file using the download button next to the file name.`]);
      });

      await Promise.all(promises);
      csvReportArray.forEach((row) => {
        csvReport += row.join(',');
        csvReport += '\n';
      });
      zip.file('file_report.csv', csvReport, {binary: true});
    },
    hideDownloadAllModal() {
      $('#downloadAllModal').modal('hide');
    },
    generateAndSaveZip(zip, zipName) {
      if (!this.isDownloadAllDistributionsCanceled) {
        this.numberOfFilesToZip = Object.keys(zip.files).length;
        this.isGeneratingZip = true;
      }

      class UserInterruptException {
        constructor(message) {
          this.message = message;
          this.name = 'UserInterruptException';
        }
      }

      zip.generateAsync({type: 'blob', compression: 'DEFLATE'}, () => {
        if (this.isDownloadAllDistributionsCanceled) throw new UserInterruptException('user canceled generate zip operation');
      })
        .then((blob) => {
          this.isGeneratingZip = false;
          this.isGeneratingZipDone = true;
          this.isLoadingAllDistributionFiles = false;
          this.downloadAllSuccess = true;
          saveAs(blob, zipName);
        })
        .catch((e) => {
          this.isGeneratingZip = false;
          this.isDownloadAllDistributionsCanceled = false;
          this.isLoadingAllDistributionFiles = false;
          this.downloadAllError = true;
          this.downloadedFilesCounter = 0;
          this.downloadProgress = 0;
          this.numberOfFilesToZip = 0;
          console.warn(e); // eslint-disable-line
        });

      // works with chrome => to make it compatible to more browsers look here https://jimmywarting.github.io/StreamSaver.js/examples/saving-multiple-files.html open developer tools and find saving-multiple-files.html
      // install stream saver and import it + script src="https://cdn.jsdelivr.net/npm/web-streams-polyfill@2.0.2/dist/ponyfill.min.js"
      // if we don't want to use his service worker we can configure something (I think we have to change the mitm url) => read the api https://jimmywarting.github.io/StreamSaver.js
      // I think IE will never work with this solution
      /* const writeStream = streamSaver.createWriteStream(zipName).getWriter();
      zip.generateInternalStream({ type: 'uint8array', streamFiles: true })
        .on('data', data => writeStream.write(data))
        .on('error', err => console.error(err))
        .on('end', () => writeStream.close())
        .resume(); */
    },
    cancelDownloadAll(source) {
      // stops axios operations
      source.cancel('user canceled axios operation');
      // stops zip operation
      this.isDownloadAllDistributionsCanceled = true;
    },
    async trackAndDownloadAllDistributions() {
      if (this.$piwik && this.$piwik.trackDownload) {
        this.$piwik.trackDownload(
          window.location.href,
          {
            files: JSON.stringify(this.files),
            downloadAll: 'true',
            format: 'all',
          }
        );
      }
      return await this.downloadAllDistributions();
    },
    async downloadAllDistributions() {
      $('#downloadAllModal').modal('show');
      this.downloadedFilesCounter = 0;
      this.downloadProgress = 0;
      this.failedDownloads = 0;
      this.numberOfFilesToZip = 0;
      this.isGeneratingZip = false;
      this.isGeneratingZipDone = false;
      this.isLoadingAllDistributionFiles = true;
      this.isDownloadAllDistributionsCanceled = false;
      this.downloadAllSuccess = false;
      this.downloadAllError = false;
      const getContentTypeFormat = (contentType) => {
        const startIndex = contentType.lastIndexOf('/') + 1;
        const endIndex = contentType.indexOf(';') !== -1 ? contentType.indexOf(';') : contentType.length;
        return contentType.substring(startIndex, endIndex);
      };

      const {default: JSZip} = await import('jszip');
      const zip = new JSZip();
      const zipName = `${this.getTranslationFor(this.getTitle, this.$route.query.locale, this.getLanguages)}.zip`;
      const folder = zip.folder(this.getTranslationFor(this.getCatalog.title, this.$route.query.locale, this.getLanguages));
      await this.fetchDistributionFiles(zip, this.files, folder, getContentTypeFormat);
      await this.generateAndSaveZip(zip, zipName);
    },
    // handle navigation to extern website (cancel bulk download and hide modal)
    beforeWindowUnload(e) {
      if (this.isLoadingAllDistributionFiles && !this.isDownloadAllDistributionsCanceled) {
        e.preventDefault();
        // Chrome requires returnValue to be set
        e.returnValue = ''; // eslint-disable-line
      }
    },
    openRessourceAccessPopup() {
      const catalogTitle = this.getTranslationFor(this.getCatalog.title, this.$route.query.locale, this.getLanguages);
      if (this.catalogsWhitelist.includes(catalogTitle)) {
        this.trackAndDownloadAllDistributions();
      } else {
        this.openModal(this.trackAndDownloadAllDistributions, true);
      }
    },
    /*onClose(e) {
      console.log("CLOSING");
    }*/
  },
  created() {
    window.addEventListener('beforeunload', this.beforeWindowUnload);
  },
  // mounted() {
  //   setTimeout(() => {
  //     const modal = document.getElementById('externalAccess');
  //     modal.addEventListener('click', function() {
  //       console.log("CLOSING");
  //     });
  //   })
  // },
  beforeUnmount() {
    window.removeEventListener('beforeunload', this.beforeWindowUnload);
    // const modal = this.$refs.downloadAllModal.$el;
    // modal.removeEventListener('hide.bs.modal', this.onClose);
  },
  setup() {
    const router = useRouter();

    onUnmounted(() => {
      router.beforeEach((to, from, next) => {
        if (this.isLoadingAllDistributionFiles && !this.isDownloadAllDistributionsCanceled) {
          const answer = window.confirm(this.$t('message.datasetDetails.datasets.leavePageWindow.text')); // eslint-disable-line
          if (answer) {
            // if modal is open we have to hide it when user tries to navigate back
            this.hideDownloadAllModal();
            this.cancelDownloadAll(this.cancelDownloadAllAxiosRequestSource);
            next();
          } else {
            next(false);
          }
        } else {
          this.hideDownloadAllModal();
          next();
        }
      })();
    })
  },
}
</script>

<style scoped>

.download-all-btn {
  font-weight: 400;

}

</style>
